import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "@/components/ui/dialog";
import { HistoricoDisponibilidadeContent } from "./HistoricoDisponibilidadeContent";

interface Props {
  freelancerId: string;
  freelancerNome: string;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function HistoricoDisponibilidadeDialog({
  freelancerId,
  freelancerNome,
  open,
  onOpenChange,
}: Props) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-3xl max-h-[85vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>Histórico de disponibilidade</DialogTitle>
          <DialogDescription>{freelancerNome}</DialogDescription>
        </DialogHeader>

        <HistoricoDisponibilidadeContent freelancerId={freelancerId} enabled={open} />
      </DialogContent>
    </Dialog>
  );
}

export default HistoricoDisponibilidadeDialog;
